import React from 'react'

import { getIn, FieldProps, Field } from 'formik'

import { FormikMaskedInput } from './FormikMaskedTextInput.styled'

type FormikTextInputProps = {
    name: string
    placeholder: string
    label: string
    mask: string
    disabled?: boolean
    info?: React.ReactNode
    helpText?: string
    infoText?: string
}

function FormikMaskedTextInput({
    name,
    placeholder,
    label,
    mask,
    disabled = false,
    info,
    infoText = '',
    helpText = '',
}: Readonly<FormikTextInputProps>) {
    let extraProps = {}

    if (React.isValidElement(info) && info?.props.children !== ' ') {
        extraProps = {
            info,
        }
    }

    return (
        <Field name={name}>
            {({ field, form }: FieldProps) => {
                const touched = getIn(form.touched, field.name)
                const error = getIn(form.errors, field.name)

                return (
                    <FormikMaskedInput
                        disabled={disabled}
                        error={!!(touched && error)}
                        helpText={error || helpText}
                        id={field.name}
                        name={field.name}
                        label={label}
                        value={field.value}
                        infoText={infoText}
                        onChange={(val: string) => {
                            const event = {
                                target: {
                                    name,
                                    value: val,
                                },
                            }

                            form.handleChange(event)
                        }}
                        onBlur={form.handleBlur}
                        placeholder={placeholder}
                        mask={mask}
                        data-testid={name}
                        {...extraProps}
                    />
                )
            }}
        </Field>
    )
}

export default FormikMaskedTextInput
